var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.user
    ? _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _vm._v(
                " Editing User: " +
                  _vm._s(_vm.user.firstName) +
                  " " +
                  _vm._s(_vm.user.lastName) +
                  " " +
                  _vm._s(
                    _vm.user.displayName ? `(` + _vm.user.displayName + `)` : ""
                  ) +
                  " "
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { color: "error" }, on: { click: _vm.toggleDisable } },
                [
                  _vm._v(
                    _vm._s(_vm.user.isAccountDisabled ? "Enable" : "Disable")
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _c("div", { staticClass: "text-h6 pb-3" }, [_vm._v("Teams")]),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.teams,
                          label: "Default Team",
                          "item-text": "name",
                          "item-value": "id",
                          outlined: "",
                          dense: "",
                          readonly: _vm.readOnly
                        },
                        model: {
                          value: _vm.defaultTeamId,
                          callback: function($$v) {
                            _vm.defaultTeamId = $$v
                          },
                          expression: "defaultTeamId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "8" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.filteredOtherTeams,
                          label: "Other teams...",
                          "item-text": "name",
                          "item-value": "id",
                          multiple: "",
                          chips: "",
                          outlined: "",
                          dense: "",
                          readonly: _vm.readOnly
                        },
                        model: {
                          value: _vm.otherTeams,
                          callback: function($$v) {
                            _vm.otherTeams = $$v
                          },
                          expression: "otherTeams"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", { staticClass: "text-h6 pb-3" }, [_vm._v("Role")]),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.roles,
                          label: "Roles",
                          "item-text": "name",
                          "item-value": "name",
                          multiple: "",
                          chips: "",
                          outlined: "",
                          dense: "",
                          readonly: _vm.readOnly
                        },
                        model: {
                          value: _vm.user.roles,
                          callback: function($$v) {
                            _vm.$set(_vm.user, "roles", $$v)
                          },
                          expression: "user.roles"
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-center justify-md-end" },
                      [
                        _c("v-btn", { on: { click: _vm.saveChanges } }, [
                          _vm._v("Save Changes")
                        ])
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }